<template>
  <div class="content_main" @scroll="handleScroll">
    <div class="banner animate__animated animate__bounceInLeft">
      <img src="../../assets/images/n-banner02.jpg" alt="">
    </div>
    <div class="bg animate__animated animate__fadeInUp">
      <div class="module-title">
		  国际化营销平台
		  <span>International Marketing Platform</span>
      </div>
      <div class="module-title">
        <div class="mt_line"></div>
        产品介绍
        <span>Product introduction</span>
      </div>
      <div class="product_introduct_text content">
        <div>
			通过数字化平台同时云展示文化与旅游资源，包括类似网红打卡地等线路内容，通过筛选，整理，展示出最合适入境游的产品与资源，同时平台可以展示国际合作伙伴的资料，双方进行立体化交流，这些内容通过云展览，云推介，云新闻中心，线上见面会等多维度形式进行推广。
        </div>
      </div>
      
      <div class="module-title">
        <div class="mt_line"></div>
        子系统
        <span>Subsystem</span>
        <div class="product_z_system content">
          <div class="tag">
            <img src="../application/images/iconsNote_21.png" alt="">
            <span>文旅资源库</span>
          </div>
          <div class="tag">
            <img src="../application/images/iconsNote_16.png" alt="">
            <span>国际文旅合作伙伴资源对接平台</span>
          </div>
          <div class="tag">
            <img src="../application/images/iconsNote_06.png" alt="">
            <span>数字化入境营销</span>
          </div>
          <div class="tag">
            <img src="../application/images/iconsNote_22.png" alt="">
            <span>海外平台官方账号运营</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <footerPage />
    </div>
  </div>
</template>

<script>
import footerPage from '../../components/footer/footer'
export default {
  components:{
    footerPage
  },
  methods: {
    handleScroll(e){
      console.log(e)
    }
  },
}
</script>

<style scoped lang='less'>
@import '../../assets/css/content.less';
.content_main{
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.bg{
  padding-bottom: 50px;
}
.banner{
  width: 100%;
  img{
    width: 100%;
    border: 0;
    display: block;
  }
}
.title{
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  h4{
    font-size: 30px;
  }
}
.module-title {
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 26px;
  color: #0080cc;
  text-align: center;
  font-weight: normal;
  span {
    display: block;
    color: #818181;
    text-transform: uppercase;
    font-size: 19px;
    margin-top: 5px;
  }
}
.mt_line {
  width: 100%;
  height: 83px;
  margin-bottom: 20px;
  background: url('./../../../static/images/ai/btline.png') no-repeat center top;
}
.product_introduct{
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 2rem;
  background: #f5f5f5;
  margin: 0 10%;
  h4{
    font-size: 30px;
    line-height: 80px;
  }
}
.product_introduct_text{
  margin-top: 2rem;
  div{
    font-size: 18px;
    line-height: 40px;
    text-indent:3rem;
    margin-bottom: 20px;
  }
}
.product_z_system{
  margin-top: 2rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .tag{
    width: 29.333%;
    margin: 1% 2%;
    height: 50px;
    font-size: 18px;
    color: #000;
    line-height: 50px;
    text-align: center;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 0 0 4%;
    img{
      height: 90%;
    }
    span{
      display: inline-block;
      width: 90%;
      display: inline-block;
      text-align: left;
      margin-left: 10px;
    }
  }
}
.image_box{
  margin: 40px 0;
  img{
    width: 100%;
    margin: 20px 0;
  }
}
.zhyx_img{
  padding: 0 1%;
  img{
    width: 100%;
  }
}
.footer{
  width: 100%;
  margin-top: 20px;
}
</style>
